<template>
    <div class="tile">
        <div class="tile-content">
            <dynamic-field-configuration
                ref="fieldConfig"
                v-if="gatewayDefinition"
                :fields="fields"
                :config="value"
                :is-updating="isUpdating"
                :gatewayName="gatewayName"
                @input="updateFields"
            />
        </div>
    </div>
</template>

<script>
    import resolveEntity from '@/common/spec/resolve-entity';
    import validationMixins from './validation-mixins';
    import DynamicFieldConfiguration from './dynamic-field-configuration';

    export default {
        name: 'gateway-config',
        mixins: [validationMixins],
        components: {
            DynamicFieldConfiguration,
        },
        props: {
            gatewayName: {
                type: String,
            },
            value: {
                type: Object,
                default: () => ({}),
            },
            /**
             * The type defines with block within the gateway's API spec properties to use.
             * By default `credentials` is rendered, but `settings` can also be used.
             */
            type: {
                type: String,
                default: 'credentials',
                validator: type => ['credentials', 'settings'].includes(type),
            },
            isUpdating: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            gatewayDefinition() {
                try {
                    // TODO update to use SpecResolver and refactor to target `credentials` directly
                    return resolveEntity(this.gatewayName);
                } catch (err) {
                    return null;
                }
            },
            gatewaySpec() {
                if (this.gatewayDefinition) {
                    const config = this.gatewayDefinition.allOf[1];
                    if (config.properties) {
                        return config.properties[this.type];
                    }
                }
                return null;
            },
            fields() {
                if (!this.gatewaySpec) {
                    return {};
                }
                return {...this.gatewaySpec};
            },
        },
        methods: {
            updateFields(data) {
                this.$emit('input', data);
            },
            getValidationAggregatorDefinition() {
                const name = `Gateway ${this.type === 'credentials' ? 'Credentials' : 'Settings'}`;
                return {
                    name: `gateway-config-${this.type}`,
                    rules: [
                        {
                            name: `${name} are invalid.`,
                            delegate: () => this.$refs.fieldConfig.validate(),
                        },
                    ],
                };
            },
        },
    };
</script>
